import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📸", key: "everyDay" },
  { emoji: "📅", key: "fewTimesWeek" },
  { emoji: "🗓️", key: "occasionally" },
  { emoji: "😔", key: "rarelyButWishMore" },
]

export default function PetsUpdateFrequencyPage() {
  return (
    <RadioCardListPage translationKey="petsUpdateFrequency" options={OPTIONS} />
  )
}
